<template>
  <HPopup class="h-forging-factory-popup"
          ref="popup"
          v-show="visible">
    <div class="h-forging-factory-popup-body">
      <p class="popup-header">锻造工厂</p>

      <div class="tabs">
        <button v-click-sound-button
                class="h-btn ADOPB2ON"
                :class="{ active: item.id === activeTab }"
                v-for="item in tabList"
                @click="activeTab=item.id">
          {{ item.name }}
        </button>
      </div>

      <div class="tab-content">
        <template v-if="activeTab === 1">
          <div class="artifact-list">
            <button v-click-sound-button class="h-btn LEFTARN" :disabled="prevDisable" @click="handlePrevPage"></button>
            <div class="artifact-list-wrapper">
              <div v-click-sound-button
                   class="artifact-item h-outer-border around-4 bw2 bz0"
                   :class="{ selected: selectedIndex === index, empty: !item.id }"
                   v-for="(item, index) in equipmentList" :key="item.name"
                   @click="handleClickArtifact(index)">
                <div class="artifact-wrapper h-effect equipment" :class="['quality-' + (item.quality || '')]">
                  <img class="artifact-icon" :src="artifactUrl(item.id)" alt="">
                </div>
              </div>
            </div>
            <button v-click-sound-button class="h-btn RIGHTARN" :disabled="nextDisable" @click="handleNextPage"></button>
          </div>

          <p class="forging-help">大人，锻造 【{{ selectedArtifact.nameCn }}】 需要以下材料：</p>
          <div class="forging-content h-outer-border around-4 bw2 bz0 h-bg brown-2">
            <div class="forging-details flex items-center">
              <div class="artifact-detail">
                <div class="synthesis-list" v-if="selectedArtifact">
                  <div class="synthesis-item h-outer-border around-4 bw2 bz0 h-title nowrap"
                       :data-title="item.nameCn"
                       v-for="item in selectedArtifact.synthesis">
                    <div class="artifact-wrapper h-effect equipment" :class="['quality-' + item.quality]">
                      <img class="artifact-icon" :src="artifactUrl(item.id)" alt="">
                    </div>
                    <div class="artifact-amount h-outer-border around-4 bw2 bz0"
                         :class="{ 'not-enough': !item.isEnough }">
                      {{ item.amount }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="forging-icon">
              <img :src="`${$rHost}/img/common/icon/icon_arrow_right.png`" alt="">
            </div>

            <div class="forging-target">
              <div class="artifact-item h-outer-border around-4 bw2 bz0">
                <div class="artifact-wrapper h-effect equipment" :class="['quality-' + selectedArtifact.quality]">
                  <img class="artifact-icon" :src="artifactUrl(selectedArtifact.id)" alt="">
                </div>
              </div>
              <div class="effects">
                <p class="effect" v-for="effectItem in selectedArtifact.effect">
                  {{ getEffectText(effectItem) }}
                </p>
              </div>
            </div>
          </div>
          <div class="footer">
            <button v-click-sound-button class="h-btn MUBCHCKN" :disabled="notEnough" @click="handleConfirm"></button>
            <button v-click-sound-button class="h-btn MUBCANCN" @click="handleClose"></button>
          </div>
        </template>
        <!-- 宝物升星  -->
        <TreasureUpgrade v-else-if="activeTab === 2"
                         :treasureList="upgradeList"
                         @close="handleClose">
        </TreasureUpgrade>
      </div>
    </div>
  </HPopup>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import HPopup from '@/components/h-popup/index.vue'
  import API from '@js/api'
  import game from '@js/game'
  import AudioCtrl from '@js/audio-ctrl'
  import HArtifactInfoBox from '@/components/h-artifact-info-box'
  import TreasureUpgrade from './treasure-upgrade'
  import AUDIO from '@/js/constants/AUDIO'
  import EQUIPMENT from '@/js/constants/EQUIPMENT'

  const { getResourceUrl, getArtifactUrl } = game
  const EFFECT_CODE_NAME = EQUIPMENT.EFFECT_CN

  const tabList = [
    {
      id: 1,
      name: '装备锻造',
    },
    {
      id: 2,
      name: '宝物升星',
    },
  ]

  export default {
    beforeDestroy () {
      if (this.audioId) {
        AudioCtrl.stop(this.audioId)
      }
    },

    filters: {
      formatUpgradeEffect(item, index) {
        if (item.isPercent) {
          return +(item.value?.[index] * 100).toFixed(1) + '%'
        }
        return item.value?.[index]
      }
    },

    data () {
      return {
        tabList,
        activeTab: 1,
        EFFECT_CODE_NAME,
        selectedIndex: 0,
        synthesisList: [],
        upgradeList: [],
        notEnough: true,
        pager: {
          page: 0,
          pageSize: 8,
          totalPage: 1,
        },
      }
    },

    computed: {
      ...mapGetters('user', [
        'userInfo',
      ]),

      ...mapGetters('hero', [
        'backpackItems',
      ]),

      equipmentList () {
        if (this.activeTab === 1) {
          return this.pageSynthesisList
        } else if (this.activeTab === 2) {
          return this.pageUpgradeList
        }
      },

      pageSynthesisList () {
        const { page, pageSize } = this.pager
        const start = page * pageSize
        const end = start + pageSize
        const list = this.synthesisList.slice(start, end)
        list.push(...new Array(pageSize).fill({}))

        return list.slice(0, pageSize)
      },

      pageUpgradeList () {
        const { page, pageSize } = this.pager
        const start = page * pageSize
        const end = start + pageSize
        const list = this.upgradeList.slice(start, end)
        list.push(...new Array(pageSize).fill({}))

        return list.slice(0, pageSize)
      },

      prevDisable () {
        return this.pager.page <= 0
      },

      nextDisable () {
        return this.pager.page >= this.pager.totalPage - 1
      },

      selectedArtifact () {
        return this.equipmentList[this.selectedIndex] || {}
      },
    },

    props: {
      visible: {
        type: Boolean,
        default: true
      },
      zIndex: {
        type: Number,
        default: 1000
      },
    },

    async mounted () {
      this.$refs.popup.$el.style.zIndex = this.zIndex
      this.audioId = AudioCtrl.play({ url: AUDIO.SCENE.LOOPSWOR, loop: false })
      await this.getBackpackItems()
      await this.getSynthesisList()
      this.handleClickArtifact(0)
    },

    methods: {
      ...mapActions('hero', [
        'getBackpackItems',
      ]),

      ...mapActions('gameSocket', [
        'appendSystemMessage'
      ]),

      getEffectText (item) {
        let label = EFFECT_CODE_NAME[item.attr]
        let symbol = item.isDecrease ? '-' : '+'
        let value = this.effectValue(item)
        if (item.attr === 'decreaseMeleePenalty') {
          symbol = ''
          value = +((0.5 + item.value) * 100).toFixed(2) + '%'
        }
        return `${label} ${symbol}${value}`
      },

      effectValue (effectItem = {}) {
        // isPercent
        if (effectItem.isPercent) {
          return +(effectItem.value * 100).toFixed(2) + '%'
        }
        return effectItem.value
      },

      getBonusIconUrl (id) {
        if (typeof id === 'string') {
          return getResourceUrl(id)
        }
        return getArtifactUrl(id)
      },

      artifactUrl (id) {
        if (!id) {
          return ''
        }
        return `${this.$rHost}/img/artifact/ARTIFACT${id}.png`
      },

      async getSynthesisList () {
        try {
          const res = await API.forgingFactory.getSynthesisList()
          res.forEach((item) => {
            item.artifactId = item.id
            item.synthesis?.forEach((d) => {
              d.isEnough = false
            })
          })
          this.synthesisList = res.filter((d) => d.synthesis)
          this.upgradeList = res.filter((d) => d.slot === 9)
          this.pager.totalPage = Math.ceil(this.synthesisList.length / this.pager.pageSize) || 1
        } catch (err) {
          console.error(err)
          this.$message(err)
        }
      },

      handlePrevPage () {
        this.selectedIndex = 0
        this.pager.page = Math.max(0, this.pager.page - 1)
        this.handleClickSynthesisArtifact(this.selectedIndex)
      },

      handleNextPage () {
        this.selectedIndex = 0
        this.pager.page = Math.min(this.pager.totalPage - 1, this.pager.page + 1)
        this.handleClickSynthesisArtifact(this.selectedIndex)
      },

      handleClickArtifact (index) {
        this.handleClickSynthesisArtifact(index)
      },

      handleClickSynthesisArtifact (index) {
        const item = this.pageSynthesisList[index]
        if (!item?.id) {
          return
        }
        this.notEnough = true
        this.selectedIndex = index
        const synthesis = item?.synthesis
        if (synthesis) {
          synthesis.forEach((d) => {
            const items = this.backpackItems.filter((b) => b.artifactId === d.id)
            const maxAmount = items.map(({ amount }) => amount).sort((a, b) => {
              return a > b ? -1 : 1
            })?.[0]
            d.isEnough = maxAmount >= d.amount
          })
          this.notEnough = synthesis.some((d) => !d.isEnough)
        }
      },

      async handleConfirm () {
        try {
          const res = await this.$confirm(`即将锻造【${this.selectedArtifact.nameCn}】，请确认。`)
          if (!res) {
            return
          }
          const synthesis = this.pageSynthesisList[this.selectedIndex]
          await API.forgingFactory.forge({ id: synthesis.id })
          this.$emit('close', false)
          this.appendSystemMessage(`【${synthesis.nameCn}】已锻造。`)
          this.getBackpackItems()
        } catch (err) {
          this.$message(err)
        }
      },

      handleClose () {
        this.$emit('close', false)
      }
    },

    components: {
      HPopup,
      HArtifactInfoBox,
      TreasureUpgrade,
    }
  }
</script>

<style lang="stylus" scoped>
  .h-forging-factory-popup-body
    width 520px

  .forging-help
    padding 20px 0 10px
    goldText1()
    text-align center
    font-size 14px

  .forging-content
    display flex
    justify-content space-between
    padding 10px 5px
    height 150px
    .forging-details
      flex-basis 0
    .forging-icon
      display flex
      align-items center
      width 70px
      img
        max-width 100%
        vertical-align top
    .forging-target
      box-sizing content-box
      display flex
      flex-direction column
      justify-content center
      align-items center
      padding 0
      width 120px
      .artifact-item
        width 64px
        height 64px
        .artifact-wrapper
          height 64px
      .effects
        width 100%
        padding-top 5px
        text-align center
        .effect
          line-height 16px
          font-size 12px
          whiteText1()
    .forging-text
      goldText1()
      text-align center
      line-height 16px
      font-size 12px

  .artifact-detail
    margin-top 10px
    .synthesis-list
      display flex
      justify-content center
      .synthesis-item
        box-sizing content-box
        width 42px
        padding 2px
        &:not(:last-child)
          margin-right 5px
        .artifact-wrapper
          width 42px
          height 42px
          .artifact-icon
            max-width 100%
            vertical-align top
        .artifact-amount
          whiteText1()
          margin-top 1px
          display flex
          justify-content center
          line-height 20px
          font-size 12px
          &.not-enough
            color $colorRed1

  .artifact-list
    display flex
    justify-content space-evenly
    .h-btn.LEFTARN,
    .h-btn.RIGHTARN
      width 27px
      height 56px
      border 2px solid $colorGold
    .artifact-list-wrapper
      display flex
      width 575px
      justify-content center
    .artifact-item
      position relative
      padding 2px
      width 56px
      height 56px
      filter grayscale(0.75)
      .artifact-wrapper
        overflow hidden
        display flex
        align-items center
        justify-content center
        width 52px
        height 52px
        img
          width 100%
          vertical-align top
      &:not(:last-child)
        margin-right 2px
      &:not(.empty):hover
        cursor pointer
      &.selected
        filter grayscale(0)

  .footer
    margin-top 40px
    display flex
    justify-content space-evenly
    > button
      box-sizing content-box

  .tabs
    display flex
    > .h-btn
      goldText1()
      margin-right 5px
      width 70px
      height 30px
      font-size 12px
      letter-spacing 1px
      filter grayscale(0.75)
      &:hover
        filter grayscale(0.5)
      &.active
        filter grayscale(0)

  .tab-content
    height 360px
    padding-top 10px
</style>
